export default __webpack_public_path__ + "static/media/social-row.66f614e5.jpg";